import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2bc3c4be&scoped=true&lang=pug"
import script from "./login.js?vue&type=script&lang=js&external"
export * from "./login.js?vue&type=script&lang=js&external"
import style0 from "../access.scss?vue&type=style&index=0&id=2bc3c4be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3c4be",
  null
  
)

export default component.exports